import React from 'react';
import Icon1 from '../images/svg-1.svg';
import Icon2 from '../images/svg-3.svg';
import Icon3 from '../images/svg-5.svg';

import {
  AboutPage,
  AboutHero,
  Eyebrow,
  AboutTitle,
  AboutLead,
  HeroEmojis,
  StatsRow,
  Stat,
  StatNum,
  StatLabel,
  Section,
  SectionHead,
  SectionTitle,
  SectionSub,
  StoryGrid,
  StoryCard,
  StoryBadge,
  StoryIllustration,
  StoryHeading,
  StoryText,
  OfferGrid,
  OfferChip,
  OfferEmoji,
  OfferLabel,
  VisitCard,
  VisitIntro,
  VisitCTA,
  VisitList,
  VisitItem,
  VisitIcon,
  VisitLabel,
  VisitValue,
} from './ServicesElements';

const stats = [
  { num: 'Since 1993', label: 'Serving Concord & beyond' },
  { num: '30+ yrs', label: 'Of trusted service' },
  { num: '#1', label: 'Oldest & largest in the area' },
  { num: 'Family', label: 'Owned & operated' },
];

const story = [
  {
    img: Icon1,
    heading: 'Rooted since 1993',
    text:
      'Bombay Trading Company has served Concord and the surrounding area for all their South Asian grocery needs — specialty spices, teas, cookies, dairy, sweets and cosmetics.',
  },
  {
    img: Icon2,
    heading: 'Treated like family',
    text:
      'Our current management, in charge for nearly two decades, strives to create a unique and personalized shopping experience — and to treat every customer like family.',
  },
  {
    img: Icon3,
    heading: 'Quality you can trust',
    text:
      'We are committed to the best quality products and proud to keep providing the best service at the oldest and largest Indian grocery store in the area.',
  },
];

const offerings = [
  { emoji: '🌶️', label: 'Spices & Masalas' },
  { emoji: '🍵', label: 'Teas & Chai' },
  { emoji: '🫘', label: 'Lentils & Dals' },
  { emoji: '🍚', label: 'Rice & Grains' },
  { emoji: '🍪', label: 'Cookies & Snacks' },
  { emoji: '🥛', label: 'Fresh Dairy' },
  { emoji: '🍬', label: 'Indian Sweets' },
  { emoji: '💄', label: 'Cosmetics' },
];

const contact = [
  { icon: '📍', label: 'Location', value: '1859 Adobe St, Concord, CA 94520' },
  { icon: '📞', label: 'Phone', value: '(925) 825-9043' },
  { icon: '✉️', label: 'Email', value: 'bombaytradingcr@gmail.com' },
  { icon: '🕛', label: 'Hours', value: 'Open daily · 12:00 PM – 8:00 PM' },
];

const Services = () => {
  return (
    <AboutPage id="services">
      <AboutHero>
        <Eyebrow>
          <span role="img" aria-label="India">🇮🇳</span> Est. 1993 · Concord, CA
        </Eyebrow>
        <AboutTitle>
          The heart of <span>authentic Indian</span> grocery
        </AboutTitle>
        <AboutLead>
          For over three decades, Bombay Trading Co has brought farm-fresh produce,
          authentic spices and beloved South Asian brands to families across the Bay Area —
          now delivered to your door, daily.
        </AboutLead>
        <HeroEmojis aria-hidden="true">
          <span role="img" aria-label="chilli">🌶️</span>
          <span role="img" aria-label="tea">🍵</span>
          <span role="img" aria-label="mango">🥭</span>
          <span role="img" aria-label="rice">🍚</span>
          <span role="img" aria-label="basket">🧺</span>
        </HeroEmojis>
      </AboutHero>

      <StatsRow>
        {stats.map((s) => (
          <Stat key={s.num}>
            <StatNum>{s.num}</StatNum>
            <StatLabel>{s.label}</StatLabel>
          </Stat>
        ))}
      </StatsRow>

      <Section>
        <SectionHead>
          <SectionTitle>Our story</SectionTitle>
          <SectionSub>
            A neighbourhood grocer built on quality, community and a love for good food.
          </SectionSub>
        </SectionHead>
        <StoryGrid>
          {story.map((c, i) => (
            <StoryCard key={c.heading}>
              <StoryBadge>0{i + 1}</StoryBadge>
              <StoryIllustration src={c.img} alt="" aria-hidden="true" />
              <StoryHeading>{c.heading}</StoryHeading>
              <StoryText>{c.text}</StoryText>
            </StoryCard>
          ))}
        </StoryGrid>
      </Section>

      <Section>
        <SectionHead>
          <SectionTitle>What we offer</SectionTitle>
          <SectionSub>
            From pantry staples to hard-to-find regional specialties — all under one roof.
          </SectionSub>
        </SectionHead>
        <OfferGrid>
          {offerings.map((o) => (
            <OfferChip key={o.label}>
              <OfferEmoji role="img" aria-label={o.label}>
                {o.emoji}
              </OfferEmoji>
              <OfferLabel>{o.label}</OfferLabel>
            </OfferChip>
          ))}
        </OfferGrid>
      </Section>

      <VisitCard>
        <VisitIntro>
          <h2>Come visit us</h2>
          <p>
            Stop by our Concord store to explore the aisles, or order online and get
            fresh Indian groceries delivered to your doorstep every day.
          </p>
          <VisitCTA to="/">Shop fresh groceries →</VisitCTA>
        </VisitIntro>
        <VisitList>
          {contact.map((c) => (
            <VisitItem key={c.label}>
              <VisitIcon role="img" aria-label={c.label}>
                {c.icon}
              </VisitIcon>
              <div>
                <VisitLabel>{c.label}</VisitLabel>
                <VisitValue>{c.value}</VisitValue>
              </div>
            </VisitItem>
          ))}
        </VisitList>
      </VisitCard>
    </AboutPage>
  );
};

export default Services;
